<template>
  <div>
    <template v-if="component">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !lock">

          <nav class="gnav theme-base-bg-color" :style="inPreview ? getThemeInlineStyle('background-color', 'base') : ''">
            <div class="gnav-header container flex justify-between">
              <h1 class="gnav-h1">
                <a class="gnav-h1-a">
                  <template v-if="logo">
                    <mimic-amp-img :image="logo"></mimic-amp-img>
                  </template>
                  <template v-else>
                    <div style="color:red">Settingsでロゴを設定して選択してください。</div>
                  </template>
                </a>
              </h1>
              <div class="gnav-right flex column justify-between items-end">
                <div class="gnav-links justify-end items-center">
                  <template v-if="contents.linkIds.length > 0">
                    <template v-for="id in contents.linkIds">
                      <a class="gnav-links-a theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" :style="inPreview ? getThemeInlineStyle('color', 'accent') + ';' + getThemeInlineStyle('border-color', 'accent') : ''">{{ getPageById(id).title.rendered }}</a>
                    </template>
                  </template>
                </div>
                <div class="gnav-info">
                  <a class="gnav-info-a flex justify-center items-center"><i class="fa fa-phone" aria-hidden="true"></i><span class="gnav-info-span">{{ contents.tel }}</span></a>
                  <p class="gnav-info-open">受付時間：{{ contents.open }}</p>
                </div>
              </div>
            </div>
            <div class="gnav-menu theme-main-bg-color" :style="inPreview ? getThemeInlineStyle('background-color', 'main') : ''">
              <div class="container">
                <template v-if="contents.menuIds.length === 0">
                  <div class="add-links">
                    ナビゲーションのリンク先を追加してください
                  </div>
                </template>
                <template v-else>
                  <ul class="gnav-menu-list flex justify-around">
                    <template v-for="(id, i) in contents.menuIds">
                      <li :key="i" class="gnav-menu-item flex justify-center items-center theme-accent-border-color" :style="inPreview ? getThemeInlineStyle('border-color', 'accent') : ''">
                        <a class="gnav-menu-a flex justify-center items-center theme-accent-color-hover">{{ getPageById(id).title.rendered }}</a>
                        <template v-if="pages.length > 0 && getSubPagesById(id).length > 0">
                          <ul class="gnav-menu-sub-list theme-accent-border-color theme-base-bg-color" :style="inPreview ? getThemeInlineStyle('border-color', 'accent') + ';' + getThemeInlineStyle('background-color', 'base') : ''">
                            <template v-for="sub in getSubPagesById(id)">
                              <li class="gnav-menu-sub-item theme-accent-border-color" :style="inPreview ? getThemeInlineStyle('border-color', 'accent') : ''"><a class="gnav-menu-sub-a theme-accent-color theme-accent-bg-color-hover" :style="inPreview ? getThemeInlineStyle('color', 'accent') : ''">{{ sub.title.rendered }}</a></li>
                            </template>
                          </ul>
                        </template>
                      </li>
                    </template>
                  </ul>
                </template>
              </div>
            </div>
          </nav>

        </div>
      </div>
      <el-dialog width="75%" title="ナビゲーションコンポーネントのコンテンツを編集" :visible.sync="isEditing">
        <el-form :model="contents">
          <el-form-item label="電話番号" :label-width="labelWidth">
            <template v-if="settings.contact.tel">
              <el-autocomplete class="width-50" v-model="contents.tel" :fetch-suggestions="telAutoComplete" placeholder="Please Input"></el-autocomplete>
            </template>
            <template v-else>
              <el-input class="width-50" v-model="contents.tel" auto-complete="off"></el-input>
            </template>
          </el-form-item>
          <el-form-item label="受付時間" :label-width="labelWidth">
            <el-input class="width-50" v-model="contents.open" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="リンクボタンの追加 (3つまで)" :label-width="labelWidth">
            <select-links :limit="3" v-model="contents.linkIds"></select-links>
          </el-form-item>
          <el-form-item label="ナビゲーションボタンの追加" :label-width="labelWidth">
            <select-links :limit="6" v-model="contents.menuIds"></select-links>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectLinks from '@/components/forms/SelectLinks'

export default {
  name: 'navigation-standard-1',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-links': SelectLinks
  },
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '15em'
    }
  },
  computed: {
    logo: function () {
      return this.$store.getters['wordpress/settings/logo']
    }
  },
  methods: {
    /**
     * settingsで設定した電話番号を自動補完する
     */
    telAutoComplete: function (query, callback) {
      const tels = [{value: this.settings.contact.tel}]
      callback(tels)
    },
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      // if (contents.menuIds.length === 0) return ''

      let anchor = ''
      contents.linkIds.forEach(id => {
        if (!this.getPageById(id)) return

        anchor += `<a class="gnav-links-a theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" href="${this.getPageById(id).link}">${this.getPageById(id).title.rendered}</a>`
      })

      let linksHtml = ''
      contents.menuIds.forEach(id => {
        if (!this.getPageById(id)) return

        let subsHtml = ''
        let subs = this.getSubPagesById(id)
        if (subs.length > 0) {
          subsHtml += `<ul class="gnav-menu-sub-list theme-accent-border-color theme-base-bg-color">`
          subs.forEach(sub => {
            subsHtml += `<li class="gnav-menu-sub-item theme-accent-border-color"><a class="gnav-menu-sub-a theme-accent-color theme-accent-bg-color-hover" href="${sub.link}">${sub.title.rendered}</a></li>`
          })
          subsHtml += `</ul>`
        }
        linksHtml += `
        <li class="gnav-menu-item flex justify-center items-center theme-accent-border-color">
          <a class="gnav-menu-a flex justify-center items-center theme-accent-color-hover" href="${this.getPageById(id).link}">${this.getPageById(id).title.rendered}</a>
          ${subsHtml}
        </li>`
      })

      const html = `
      <nav class="gnav theme-base-bg-color">
        <div class="gnav-header container flex justify-between">
          <h1 class="gnav-h1">
            <a class="header-h1-a" href="${this.url}">
              <amp-img width="${this.logo.width}" height="${this.logo.height}" layout="responsive" src="${this.logo.src}" alt="${this.settings.site.owner}ロゴ画像" attribution="${this.settings.site.owner} All Rights Reserved."><p fallback>${this.settings.site.owner}</p>
              </amp-img>
            </a>
          </h1>
          <div class="gnav-right flex column justify-between items-end">
            <div class="gnav-links flex justify-end items-center">${anchor}</div>
            <div class="gnav-info">
              <a class="gnav-info-a flex justify-center items-center" href="tel:${contents.tel}"><i class="fa fa-phone" aria-hidden="true"></i><span class="gnav-info-span">${contents.tel}</span></a>
              <p class="gnav-info-open">受付時間：${contents.open}</p>
            </div>
          </div>
        </div>
        <div class="gnav-menu theme-main-bg-color">
          <div class="container">
            <ul class="gnav-menu-list flex justify-around">${linksHtml}</ul>
          </div>
        </div>
      </nav>`
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '')
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      return {layout, theme}
    }
  },
  created: function () {
    // contents.linkIds/contents.menuIdsに固定ページが見つからなければ削除する
    this.component.contents.linkIds = this.component.contents.linkIds.filter(id => this.getPageById(id))
    this.component.contents.menuIds = this.component.contents.menuIds.filter(id => this.getPageById(id))
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import "./NavigationStandard1.scss";
}
.smartphone,
.tablet,
.desktop {
  @import "./NavigationStandard1.s.scss";
}
.tablet,
.desktop {
  @import "./NavigationStandard1.m.scss";
}
.desktop {
  @import "./NavigationStandard1.l.scss";
}
.add-links {
  padding: 5em 0;
  text-align: center;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationStandard1/NavigationStandard1.vue